export const getpath = (comp, icon) => {
  console.log("Current Path " + comp);
  return {
    type: "Current Route",
    payload: comp,
    icon: icon
  };
};



// WEBPACK FOOTER //
// ./src/actions/get-path.js